<ng-container [ngSwitch]="mode">
  <ng-container *ngSwitchCase="'OLD'">
    <app-old-reports-form></app-old-reports-form>
  </ng-container>

  <ng-container *ngSwitchDefault>
    <app-reports-form></app-reports-form>
  </ng-container>
</ng-container>
